import { FC } from 'react';
import { Button, Icon } from '@aidkitorg/component-library';
import { useLocalizedStrings } from '../../../../Localization';
import { InfoField } from './InfoField';

export interface PhoneTabProps {
  phoneNumber?: string;
  email?: string;
}

export const PhoneTab: FC<PhoneTabProps> = ({ phoneNumber, email }) => {
  const L = useLocalizedStrings();

  return (
    <div className="flex flex-col space-y-6">
      {/* Phone Actions Section */}
      <div className="pb-6 border-b border-gray-200 min-w-0">
        <h3 className="text-sm font-semibold text-gray-500 uppercase mb-3">{L.applicant.comms.phone_actions}</h3>
        <div className="space-y-3 min-w-0">
          <Button
            variant="primary"
            className="w-full"
            icon={<Icon name="PhoneIcon" className="h-3 w-3" />}
            iconPlacement="left"
            onClick={() => {
              // TODO: Implement call functionality
            }}
          >
            {L.applicant.comms.call}
          </Button>
          <Button
            variant="secondary"
            className="w-full"
            icon={<Icon name="PhoneIcon" className="h-3 w-3" />}
            iconPlacement="left"
            onClick={() => {
              // TODO: Implement conference call functionality
            }}
          >
            {L.applicant.comms.start_conference}
          </Button>
        </div>
      </div>

      {/* Contact Information Section */}
      <div className="min-w-0">
        <h3 className="text-sm font-semibold text-gray-500 uppercase mb-3">{L.applicant.comms.contact_information}</h3>
        <div className="space-y-3 min-w-0">
          <InfoField label={L.support.phone_number} value={phoneNumber || L.support.na} />
          <InfoField label={L.support.email} value={email || L.support.na} />
        </div>
      </div>
    </div>
  );
};
